<template>
  <div>
    <div>
      <v-img
        :src="
          $vuetify.breakpoint.mdAndUp
            ? '/portadas-hor-cole-prepa.jpg'
            : '/portadas-ver-cole-prepa.jpg'
        "
        height="100vh"
        gradient="to top right, rgba(0,0,0,.10), rgba(0,0,0,.10)"
        class="align-center"
      >
        <h1
          class="white--text text-center font-weight-bold text-uppercase"
          :class="[
            $vuetify.breakpoint.xl
              ? 'display-4'
              : $vuetify.breakpoint.mdAndUp
              ? 'display-2'
              : 'display-1',
          ]"
        >
          {{ general.name }}
        </h1>
        <!--         <div align="center">
          <br>
          <v-btn dark color="primary white--text" x-large @click="$store.dispatch('agendDate/modalSend', true)">
            Agenda tu cita
          </v-btn>            
        </div>  -->
        <Boton />
      </v-img>
    </div>
    <v-row class="mx-0">
      <ColorBanner
        :description="general.description"
        bgcolor="pattern-secondary"
        descriptionClass="font-weight-medium"
      />
      <div v-for="(item, i) in general.grids" :key="i">
        <left-image
          v-if="i % 2 == 0"
          :textArray="item.gridelements"
          :hasTitle="false"
          :image="renderMedia(item.portada)"
          textClass="justify-text"
          colClass="py-12"
        />
        <right-image
          v-if="i % 2 == 1"
          :textArray="item.gridelements"
          :hasTitle="false"
          :image="renderMedia(item.portada)"
          textClass="justify-text"
          colClass="py-12"
        />
      </div>
      <ColorBanner
        v-if="
          general.metodologia_description != null &&
          general.metodologia_description != ''
        "
        :title="general.metodologia_title"
        :description="general.metodologia_description"
        bgcolor="pattern-primary"
        descriptionClass="mb-12"
      />
      <CardMision
        :array="general.objetive_texts"
        title="Nuestro Objetivo"
        :image="renderMedia(general.objetive_img)"
        imageClass="accent"
      />
      <ColorBanner
        title="Programas Institucionales"
        description="Además de las asignaturas básicas establecidas por las autoridades educativas, ofrecemos a nuestros alumnos los siguientes servicios complementarios:"
        bgcolor="primary"
        titleClass="white--text mb-5"
        descriptionClass="white--text"
      />
      <v-row class="mx-0 color white--text">
        <v-col
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="4"
          offset-md="1"
          offset-lg="1"
          offset-xl="2"
        >
          <ul style="list-style: none" class="py-8">
            <li v-for="(item, index) in general.complements1" :key="index">
              <h3 class="py-2 font-weight-regular">
                <i class="mdi mdi-chevron-right"></i>
                {{ item.text }}
              </h3>
            </li>
          </ul>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="5" xl="4">
          <ul style="list-style: none" class="py-8">
            <li v-for="(item, index) in general.complements2" :key="index">
              <h3 class="py-2 font-weight-regular">
                <i class="mdi mdi-chevron-right"></i>
                {{ item.text }}
              </h3>
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row class="mx-0">
        <v-col
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="4"
          offset-md="1"
          offset-lg="1"
          offset-xl="2"
        >
          <ul style="list-style: none" class="py-8" align="justify">
            <li v-for="(item, index) in general.complements3" :key="index">
              <h3 class="py-2 font-weight-regular">
                <i class="mdi mdi-chevron-right"></i>
                {{ item.text }}
              </h3>
            </li>
          </ul>
        </v-col>
        <v-col cols="12" sm="12" md="5" lg="5" xl="4">
          <ul style="list-style: none" class="py-8" align="justify">
            <li v-for="(item, index) in general.complements4" :key="index">
              <h3 class="py-2 font-weight-regular">
                <i class="mdi mdi-chevron-right"></i>
                {{ item.text }}
              </h3>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-row>
    <v-row
      v-if="instalaciones.length > 0"
      class="mx-0"
      align="center"
      justify="center"
      style="background-color: #8e0d2c"
    >
      <v-col cols="10" sm="10" md="12" lg="6">
        <h1
          :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : ''"
          class="
            white--text
            text-center text-uppercase
            my-12
            font-weight-regular
          "
        >
          Conoce nuestras instalaciones
        </h1>
      </v-col>
    </v-row>
    <v-row
      v-for="the_row in instalaciones"
      :key="the_row.id"
      class="justify-center align-center px-12"
      :class="[$vuetify.breakpoint.mdAndUp ? '' : 'mx-0 px-5']"
    >
      <v-col
        cols="12"
        :sm="the_row.length == 3 ? 4 : the_row.length == 2 ? 6 : 12"
        v-for="the_row_son in the_row"
        :key="the_row_son.id"
      >
        <v-img
          :src="renderMedia(the_row_son.picture)"
          aspect-ratio="1.7"
        ></v-img>
      </v-col>
    </v-row>
  </div>
</template>
<style scoped>
.justify-text {
  text-align: justify;
}
.imageClass {
  background-color: #8e0d2c !important;
  background-size: cover !important;
  background-position: center !important;
}
.color {
  background-color: #8e0d2c !important;
}
</style>
<script>
import Boton from "../components/Boton.vue";
import RightImage from "../components/RightImage.vue";
import LeftImage from "../components/LeftImage.vue";
import ColorBanner from "../components/ColorBanner.vue";
import CardMision from "../components/CardMision.vue";
import { mapState } from "vuex";
import axios from "axios";
export default {
  components: {
    Boton,
    RightImage,
    LeftImage,
    ColorBanner,
    CardMision,
  },
  mounted() {
    if (this.city_options != null) {
      this.setData();
      this.$store.dispatch("cities/getFeedDataPhones", {
        level: "Preparatoria",
        campus: this.city_options.link,
      });
      this.getInstallations();
    }
  },
  data: () => ({
    dialog: false,
    instalaciones: [],
    publicPath: process.env.BASE_URL,
    general: {
      name: "",
      portada: "",
      description:
        "Los niños Vizcaya adoptan sus propios valores, son dignos y valiosos por sí mismos, los que en un ambiente adecuado podrán actuar libremente confiando en su curiosidad innata y siendo constructores de su propio aprendizaje.",
      grids: [
        {
          text: "Fomentamos el aprendizaje mediante la interacción y colaboración entre profesores, alumnos y padres de familia. <br>A través de éstas el alumno se apropia de conocimientos, actitudes y competencias para su desarrollo integral en una relación de interdependencia en la que se definen metas comunes al grupo y que trascienden el ámbito escolar.",
        },
        {
          text: "Contamos con el reconocimiento ante la SEP, con el Registro de validez oficial.",
        },
        { text: "<b>RVOE – EBPR/1817/301/2008</b>" },
      ],
      objetive_texts: [
        { text: "Lectura activa", isTitle: true },
        {
          text: "Es la formación integral de la persona, en un ambiente de confianza, intercambio personal y colaboración. Dentro del cual cada una se sienta reconocida, valorada, aceptada y estimulada para conquistar su propio desarrollo y adquirir un compromiso de respuesta.",
        },
      ],
      complements1: [],
      complements2: [],
      complements3: [],
      complements4: [],
    },
  }),
  methods: {
    renderMedia(media) {
      if (media != null && media != undefined) {
        if (media.indexOf("https") < 0) {
          return "https://adminuva.tidingo.com/" + media;
        } else {
          return media;
        }
      } else {
        return "";
      }
    },
    setData() {
      var the_data = this.city_options.preparatoria;
      if (the_data != null) {
        this.general = the_data;
        var complements_array = _.chunk(the_data.complement_texts, 3);
        this.general.complements1 = complements_array[0];
        this.general.complements2 = complements_array[1];
        this.general.complements3 = complements_array[2];
        this.general.complements4 = complements_array[3];
      }
    },
    getInstallations() {
      var self = this;
      var url =
        "https://adminuva.tidingo.com/api/data-colegio-installations?level=Preparatoria&campus=";
      var cselected = self.city_options.name;
      axios({
        method: "get",
        url: url + cselected,
        config: {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          withCredentials: true,
          credentials: "same-origin",
        },
      })
        .then(function (response) {
          var val = response.data.data;
          if (val.length % 3 == 0) {
            var general = _.chunk(val, 3);
            var total = [];
            for (var i = 0; i < general.length; i++) {
              var rand = Math.floor(Math.random() * 2);
              rand = rand + 1;
              switch (rand) {
                case 1:
                  var the_result = _.chunk(general[i], 2);
                  for (var da = 0; da < the_result.length; da++) {
                    total.push(the_result[da]);
                  }
                  break;
                case 2:
                  total.push(general[i]);
                  break;
              }
            }
            self.instalaciones = total;
          } else {
            self.instalaciones = _.chunk(val, 3);
          }
        })
        .catch(function (error) {});
    },
  },
  computed: {
    ...mapState({
      campus: (state) => state.cities.campus,
      city_options: (state) => state.cities.city_options,
      city_selected: (state) => state.cities.city_selected,
      cities: (state) => state.cities.cities,
      vida: (state) => state.cities.vida,
      link_location: (state) => state.cities.link_location,
      link_information: (state) => state.cities.link_information,
    }),
  },
  watch: {
    city_options() {
      this.setData();
    },
  },
};
</script>
